module.exports = __webpack_public_path__ + "img/17840_L.52054f51.png";